import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
// import App from './app';
import Carousel from './banner';
import Products from './products';
import About from './About';
import Services from './Services';
import Facts from './Facts';
import Partners from './Partners';
import FAQ from './FAQ';
import Blog from './Blog';
import Quote from './Quote';
import Footer from './Footer';
// import { Link } from 'react-router-dom';

const Home = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    if (window.WOW) {
      new window.WOW().init();
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🌀 Scroll progress logic
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? (scrollTop / docHeight) * 307.919 : 0; // stroke length
      setScrollProgress(progress);
      setShowScroll(scrollTop > 200);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 🧭 Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-200 space-y-0 relative">
      <Navbar />
      <Carousel />
     
      <About />
       <Products />
      <Services />
      <Facts />
      <Partners />
      <FAQ />
      <Blog />
      <Quote />
      <Footer />

      {/* 🟦 Scroll to Top Button with Circular Progress */}
      {showScroll && (
        <div
          onClick={scrollToTop}
          className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
        >
          <svg
            className="progress-circle -rotate-90 w-12 h-12 absolute"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              fill="none"
              stroke="white"
              strokeWidth="4"
              strokeDasharray="307.919"
              strokeDashoffset={307.919 - scrollProgress}
              style={{
                transition: 'stroke-dashoffset 0.1s linear',
              }}
            />
          </svg>

          {/* ↑ Arrow Icon Center */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-white relative z-10"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default Home;
